<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}">文华下单专用键盘介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p style='float:left'>
                外接交易键盘，USB线插入后，系统会自动识别安装，<br />
                无需人工做任何操作即可使用。<br>
                <br>
                适用于一般交易者
                <br>
                <br>
                规格：194mm x 123mm
            </p>
            <p style='float:right;margin-right:50px;'>
                <a href="https://www.wenhua.com.cn/popwin/xiadanjp2.htm" target="_blank">
                    <img style='width:401px;height:212px;' src="@/assets/image/keyboard.png" />
                </a>
            </p>
            <div style='clear:both;'></div>
            <h5 style='margin-top:-30px;'>左区按键说明</h5>
            <p><b style="white-space: nowrap;">下单专用键盘：</b>预先设置买/卖和开/平方向后，实现一键迅速下单。<br>
                委托方向（买/卖）、委托类型（开/平/平今），委托价格（挂/对手价/超价）都可事先通过按键设定好，当需要<br>
                下单时直接点击“下单”按钮即可一步完成下单。
            </p>
            <p style="color:rgb(93, 29, 46);">[注意]</p>
            <p style="color:rgb(93, 29, 46);">1.默认值：买卖方向默认为买入，委托类型默认为开仓，委托价格默认为挂价。</p>
            <p style="color:rgb(93, 29, 46);">2.挂  价：买入以买价发委托，卖出以卖价发委托。</p>
            <p style="color:rgb(93, 29, 46);">3.对手价：买入以卖价发委托，卖出以买价发委托。</p>
            <p style="color:rgb(93, 29, 46);">4.超 价：买入以“基准价”+N个变动价位发委托，卖出以“基准价”-N个变动价位发委托。“基准价”和N可以在交易界面左侧【超价参数】中设置。</p>
            


            <h5>右区按键说明</h5>
            <table>
                <tr>
                    <th style='width: 80px;'>按键名称</th>
                    <th>详解</th>
                </tr>
                <tr>
                    <td><img src="@/assets/image/zhong.png" /></td>
                    <td>开/关下单键盘在电脑上显示的窗口（以下简称“键盘窗口”），在下单过程中如有弹出“是/否”需要确认时该键充当“否”键。</td>
                </tr>
                
                <tr>
                    <td>Enter</td>
                    <td>在下单过程中如有弹出“是/否”需要确认时该键充当“是”键。</td>
                </tr>
                <tr>
                    <td>++/--</td>
                    <td>手数加/减1</td>
                </tr>
                <tr>
                    <td>撤单</td>
                    <td>撤掉键盘窗口中显示合约的全部挂单，不需确认。</td>
                </tr>
                <tr>
                    <td>反手</td>
                    <td>
                        <p style='color:#2c3e50;'>对键盘窗口中显示合约的持仓以对手价进行反手操作，不需确认。</p>
                        <p style="color:rgb(93, 29, 46);">[注意]</p>
                        <p style="color:rgb(93, 29, 46);">1.锁仓不支持反手;</p>
                        <p style="color:rgb(93, 29, 46);">2.反手委托方式可通过交易界面左侧参数设置->选项设置->反手默认下单方式中修改。</p>
                    </td>
                </tr>
                <tr>
                    <td>全平</td>
                    <td>对键盘窗口中显示合约的持仓以对手价进行全平，不需确认。</td>
                </tr>
            </table>

            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 1">
            
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.下单键盘需使用文华<common-data name="appShortName_10"/>、<common-data name="appShortName_12"/>软件，其他软件不支持。</p>
            <p class="tent">2.无需安装驱动，即插即用。</p>
            <p class="tent">3.收到下单键盘后一个月内如有质量问题，可与文华财经联系换货。</p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn{
    min-height: 255px;
}
.details_gn p {
    display: flex;
}
.details_gn h5{
    font-size: 15px;
    color: rgb(48, 49, 51);
    position: relative;
    padding-left: 5px;
}
.details_gn h5::before{
    content: '';
    position: absolute;
    left: 0;
    top: 3px;
    height: 15px;
    width: 3px;
    background: rgb(63, 135, 255);

}
.details_gn table{
    font-size: 14px;
}
.details_gn table td{
    text-align: left;
}
.details_gn table tr td:first-child {
    text-align: center;
}
.details_gn table th{
    padding:13px 15px;
    font-weight: normal;
}
.details_gn{
    position: relative;
}
</style>